import { Action, Dispatch } from "redux";
import API from "../../services/api";
import { createStatusMessage } from "../ui/StatusMessage";
import { statusAdd } from "../ui/action";
import { Map, Field } from "typings";
export interface LoadTranslationsAction extends Action
{
    type: "LOAD_TRANSLATIONS";
    translations: Map<string>;
    fieldName: string;
    language: string;
}

export interface LoadFieldValuesAction extends Action
{
    type: "LOAD_FIELD_VALUES";
    fieldValues: string[];
    fieldName: string;
}

export interface LoadFieldsAction extends Action
{
    type: "LOAD_FIELDS";
    fields: Field[];
}

export const loadFieldValues = (fieldName: string, valuesUrl: string ) => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        const fieldValues = await API.product.fetchFieldData(valuesUrl);
        const action: LoadFieldValuesAction = { type: "LOAD_FIELD_VALUES", fieldName, fieldValues };
        dispatch(action); 
    }
    catch
    {
        const status = createStatusMessage("Loading field values failed", "error", "product");
        dispatch(statusAdd(status));
    }
};

export const loadTranslations = (fieldName: string, language: string, valuesUrl: string) => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        const translations = await API.product.fetchFieldTranslations(valuesUrl, language);
        const action: LoadTranslationsAction = { type: "LOAD_TRANSLATIONS", fieldName, language, translations };
        dispatch(action); 
    }
    catch
    {
        const status = createStatusMessage("Loading field values failed", "error", "product");
        dispatch(statusAdd(status));
    }
};

export const addOrUpdateFieldValue = (fieldName: string, language: string, valuesUrl: string, key: string, value: string) => 
    async (dispatch: any) =>
{
    try
    {
        await API.product.updateFieldTranslations(valuesUrl, language, key, value);
        dispatch(loadTranslations(fieldName, language, valuesUrl));
    }
    catch
    {
        const status = createStatusMessage("Updating field translations failed", "error", "product");
        dispatch(statusAdd(status));
    }
};



export const loadFields = () => async (dispatch: Dispatch<Action>) =>
{
    try
    {
        const fields = await API.product.getFields();
        const action: LoadFieldsAction = { type: "LOAD_FIELDS", fields };
        dispatch(action); 
    }
    catch
    {
        const status = createStatusMessage("Loading fields", "error", "product");
        dispatch(statusAdd(status));
    }
};

export type Actions = 
    LoadTranslationsAction |
    LoadFieldValuesAction | 
    LoadFieldsAction;



// WEBPACK FOOTER //
// ./src/state/field/action.ts